import BaseModel from "../../../common/model/base_model";

export default class ResetPasswordModel extends BaseModel {

    cluster = '';
    login = '';

    constructor(cluster) {
        super();

        if (cluster) {
            this.cluster = cluster;
        }
    }

}